// WARNING: This file is autogenerated by @atomic-ehr/codegen.
// GitHub: https://github.com/atomic-ehr/codegen
// Any manual changes made to this file may be overwritten.

import type { BackboneElement } from "../hl7-fhir-r4-core/BackboneElement";
import type { CodeableConcept } from "../hl7-fhir-r4-core/CodeableConcept";
import type { Coding } from "../hl7-fhir-r4-core/Coding";
import type { ContactDetail } from "../hl7-fhir-r4-core/ContactDetail";
import type { DomainResource } from "../hl7-fhir-r4-core/DomainResource";
import type { Identifier } from "../hl7-fhir-r4-core/Identifier";
import type { UsageContext } from "../hl7-fhir-r4-core/UsageContext";

export type { BackboneElement } from "../hl7-fhir-r4-core/BackboneElement";
export type { CodeableConcept } from "../hl7-fhir-r4-core/CodeableConcept";
export type { Coding } from "../hl7-fhir-r4-core/Coding";
export type { ContactDetail } from "../hl7-fhir-r4-core/ContactDetail";
export type { Identifier } from "../hl7-fhir-r4-core/Identifier";
export type { UsageContext } from "../hl7-fhir-r4-core/UsageContext";

export interface CodeSystemConcept extends BackboneElement {
    code: string;
    concept?: CodeSystemConcept[];
    definition?: string;
    designation?: CodeSystemConceptDesignation[];
    display?: string;
    property?: CodeSystemConceptProperty[];
}

export interface CodeSystemConceptDesignation extends BackboneElement {
    language?: string;
    use?: Coding;
    value: string;
}

export interface CodeSystemConceptProperty extends BackboneElement {
    code: string;
    valueBoolean?: boolean;
    valueCode?: string;
    valueCoding?: Coding;
    valueDateTime?: string;
    valueDecimal?: number;
    valueInteger?: number;
    valueString?: string;
}

export interface CodeSystemFilter extends BackboneElement {
    code: string;
    description?: string;
    operator: ("=" | "is-a" | "descendent-of" | "is-not-a" | "regex" | "in" | "not-in" | "generalizes" | "exists")[];
    value: string;
}

export interface CodeSystemProperty extends BackboneElement {
    code: string;
    description?: string;
    type: ("code" | "Coding" | "string" | "integer" | "boolean" | "dateTime" | "decimal");
    uri?: string;
}

// CanonicalURL: http://hl7.org/fhir/StructureDefinition/CodeSystem
export interface CodeSystem extends DomainResource {
    resourceType: "CodeSystem";

    caseSensitive?: boolean;
    compositional?: boolean;
    concept?: CodeSystemConcept[];
    contact?: ContactDetail[];
    content: ("not-present" | "example" | "fragment" | "complete" | "supplement");
    copyright?: string;
    count?: number;
    date?: string;
    description?: string;
    experimental?: boolean;
    filter?: CodeSystemFilter[];
    hierarchyMeaning?: ("grouped-by" | "is-a" | "part-of" | "classified-with");
    identifier?: Identifier[];
    jurisdiction?: CodeableConcept[];
    name?: string;
    property?: CodeSystemProperty[];
    publisher?: string;
    purpose?: string;
    status: ("draft" | "active" | "retired" | "unknown");
    supplements?: string;
    title?: string;
    url?: string;
    useContext?: UsageContext[];
    valueSet?: string;
    version?: string;
    versionNeeded?: boolean;
}
export const isCodeSystem = (resource: unknown): resource is CodeSystem => {
    return resource !== null && typeof resource === "object" && (resource as {resourceType: string}).resourceType === "CodeSystem";
}
